// extracted by mini-css-extract-plugin
module.exports = {"btn":"FooterShare_btn_1jcpN"};